import EnvolvidosListCard from "./EnvolvidosListCard";

export default EnvolvidosListCard;